module.exports = __webpack_public_path__ + "img/logo-police.2c589ac5.png";